var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.732,
    height: 25.32,
    viewBox: "0 0 28.732 25.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "device",
    transform: "translate(-38.5 -589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37271",
    "data-name": "Path 37271",
    d: "M17,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V5A3,3,0,0,0,17,2Zm1,17a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4H17a1,1,0,0,1,1,1Zm-5.29-2.71A1,1,0,0,0,11.8,16l-.18.06a.76.76,0,0,0-.18.09l-.15.12a1.034,1.034,0,0,0,0,1.42,1.46,1.46,0,0,0,.33.22A1,1,0,0,0,13,17a.84.84,0,0,0-.08-.38,1.15,1.15,0,0,0-.21-.33Z",
    transform: "translate(48.536 585.268) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18334",
    "data-name": "Rectangle 18334",
    width: 2,
    height: 12,
    rx: 1,
    transform: "translate(44.5 591) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18335",
    "data-name": "Rectangle 18335",
    width: 2,
    height: 12,
    rx: 1,
    transform: "translate(65.5 600.66) rotate(30)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.147d34107742b89dfeef97a0e96000a2.svg";
export { ForwardRef as ReactComponent };